import { createAction, props, union } from '@ngrx/store';

import { PaxDetailsFormData } from '@fcom/dapi/interfaces';

export const setPaxDetails = createAction(
  '[PaxDetailsActions] SetPaxDetails',
  props<{ passengers: PaxDetailsFormData[] }>()
);
export const reset = createAction('[PaxDetailsActions] Reset');
export const setCorporateCode = createAction(
  '[PaxDetailsActions] SetCorporateCode',
  props<{ corporateCode: string }>()
);

const all = union({ setPaxDetails, reset, setCorporateCode });

export type ActionsUnion = typeof all;
